import { cn, formatMoney, formatPriceRange, discountPercent } from '../../lib/format.js';

/**
 * Price, compare-at strikethrough, and the saving.
 *
 * A variable product shows a range rather than a "from" price, because "from
 * ₹2,499" on a product whose only stocked size is ₹4,199 is the kind of accuracy
 * that produces a support ticket.
 */

const sizes = {
  sm: { price: 'text-sm', compare: 'text-2xs', badge: 'text-2xs' },
  md: { price: 'text-base', compare: 'text-xs', badge: 'text-2xs' },
  lg: { price: 'text-xl', compare: 'text-sm', badge: 'text-xs' },
};

export const PriceTag = ({
  price,
  compareAtPrice = 0,
  priceRange,
  isVariable = false,
  size = 'md',
  showSaving = true,
  className,
}) => {
  const scale = sizes[size] ?? sizes.md;
  const saving = discountPercent(price, compareAtPrice);

  const display = isVariable && priceRange ? formatPriceRange(priceRange, price) : formatMoney(price);

  return (
    <div className={cn('flex flex-wrap items-baseline gap-x-2 gap-y-1', className)} data-numeric>
      <span className={cn('font-medium text-brand', scale.price)}>{display}</span>

      {saving > 0 && (
        <>
          <span className={cn('text-muted line-through', scale.compare)}>
            {formatMoney(compareAtPrice)}
          </span>
          {showSaving && (
            <span className={cn('font-semibold tracking-[0.06em] text-success uppercase', scale.badge)}>
              {saving}% off
            </span>
          )}
        </>
      )}
    </div>
  );
};

export default PriceTag;
